import React, { useState } from 'react';

export default function VisitorInfoModal({ onSave }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name.trim() || !phone.trim()) {
      alert('Please enter your name and phone number');
      return;
    }

    const visitor = {
      name: name.trim(),
      phone: phone.trim(),
    };

    localStorage.setItem('visitorInfo', JSON.stringify(visitor));

    onSave(visitor);
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={iconStyle}>👋</div>

        <h2 style={titleStyle}>Welcome!</h2>

        <p style={descriptionStyle}>
          Please enter your information before viewing the menu.
        </p>

        <form onSubmit={handleSubmit}>
          <label style={labelStyle}>Your Name</label>

          <input
            type="text"
            placeholder="Enter your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={inputStyle}
          />

          <label style={labelStyle}>Phone Number</label>

          <input
            type="tel"
            placeholder="e.g. 0712345678"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            style={inputStyle}
          />

          <button type="submit" style={buttonStyle}>
            Continue
          </button>
        </form>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.55)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px',
  zIndex: 9999,
};

const modalStyle = {
  width: '100%',
  maxWidth: '400px',
  background: '#fff',
  borderRadius: '24px',
  padding: '28px 22px',
  boxShadow: '0 20px 50px rgba(0,0,0,0.2)',
};

const iconStyle = {
  width: '60px',
  height: '60px',
  borderRadius: '50%',
  background: '#F3F4F6',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '30px',
  margin: '0 auto 15px',
};

const titleStyle = {
  textAlign: 'center',
  margin: '0 0 8px',
};

const descriptionStyle = {
  textAlign: 'center',
  color: '#6B7280',
  marginBottom: '25px',
};

const labelStyle = {
  display: 'block',
  fontSize: '14px',
  fontWeight: '600',
  marginBottom: '7px',
  marginTop: '15px',
};

const inputStyle = {
  width: '100%',
  boxSizing: 'border-box',
  padding: '13px 14px',
  border: '1px solid #D1D5DB',
  borderRadius: '12px',
  fontSize: '15px',
  outline: 'none',
};

const buttonStyle = {
  width: '100%',
  marginTop: '25px',
  padding: '14px',
  border: 'none',
  borderRadius: '12px',
  background: '#111827',
  color: '#fff',
  fontSize: '16px',
  fontWeight: '600',
  cursor: 'pointer',
};